import { css } from '@linaria/core';
import { colors } from '@spaceshipapp/cambridge';

export const stackStyle = css`
  max-width: 25rem;
`;

export const inlineStyle = css`
  display: flex;
  column-gap: 0.5rem;
`;
export const selectStyle = css`
  background: none;
`;

export const helpMessageStyle = css`
  display: block;
`;

export const mailTextStyle = css`
  font-size: 0.95rem;
`;

export const supportTextStyle = css`
  color: ${colors.subtext};
  line-height: 120%;
  margin-bottom: -1rem;
`;

export const exportRequirementLinkStyle = css`
  margin-left: 2.5rem;
  margin-top: 1rem;
`;
